export default __webpack_public_path__ + "static/banner-web-application-development-594578af9ffe4b205ee6f4eabad2b7dc.jpg";